"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _commonTable = _interopRequireDefault(require("./common-table.vue"));
_commonTable.default.install = function (Vue) {
  Vue.component('common-table', _commonTable.default);
};
var _default = exports.default = _commonTable.default;